import {Component, OnInit} from '@angular/core';
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {GridHorariosEditService} from "../../superadmin/cad-empresas/grid-horarios-edit-service";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import {ModalConfirmacaoComponent} from "./modal-confirmacao.component";

declare var moment;

@Component({
  selector: 'app-modal-adicionar-horario',
  templateUrl: './modal-adicionar-horario.component.html',
  styleUrls: ['./modal-adicionar-horario.component.scss']
})
export class ModalAdicionarHorarioComponent implements OnInit {
  empresa: any = {};
  servico: any;
  horarioParaEditar: any = null;
  diaSelecionado: number = null;
  editService: GridHorariosEditService;
  modoSemana = false;
  diaSemana: number = null;
  msgErro: string;
  diasDaSemana = [
    {dia: 1, descricao: 'Segunda', abreviacao: 'Seg'},
    {dia: 2, descricao: 'Terça', abreviacao: 'Ter'},
    {dia: 3, descricao: 'Quarta', abreviacao: 'Qua'},
    {dia: 4, descricao: 'Quinta', abreviacao: 'Qui'},
    {dia: 5, descricao: 'Sexta', abreviacao: 'Sex'},
    {dia: 6, descricao: 'Sábado', abreviacao: 'Sáb'},
    {dia: 0, descricao: 'Domingo', abreviacao: 'Dom'}
  ];

  diasSelecionados: number[] = [];
  turnos: any[] = [{ inicio: null, fim: null , id: null, removido:  null}];
  salvando = false;
  dataMaxima = new Date();
  dataMinima = new Date();
  constructor(private dialogRef: DialogRef, private dialogService: DialogService) {}

  ngOnInit() {
    if (this.horarioParaEditar) {
      // Modo edição
      this.diasSelecionados = [this.diaSelecionado];
      this.turnos = [{
        id: this.horarioParaEditar.id,
        inicio: moment(this.horarioParaEditar.horarioAbertura, 'HH:mm:ss').toDate(),
        fim: moment(this.horarioParaEditar.horarioFechamento, 'HH:mm:ss').toDate()
      }];
    } else if (this.modoSemana && this.diaSemana !== null) {
      // Modo semana - carregar todos os horários do dia
      this.carregarHorariosDoDia();
    }

    this.dataMaxima.setHours(23)
    this.dataMaxima.setMinutes(59)

  }

  getDiaSemanaDescricao(): string {
    if (this.diaSemana === null) return '';
    const diaObj = this.diasDaSemana.find(d => d.dia === this.diaSemana);
    return diaObj ? diaObj.descricao : '';
  }

  carregarHorariosDoDia() {
    // Carregar todos os horários do dia específico
    const horariosDoDia = this.empresa.horariosFuncionamento?.filter(h =>
      h.servico === this.servico.id &&
      h.diaDaSemana === this.diaSemana &&
      h.funciona
    ) || [];

    this.diasSelecionados = [this.diaSemana];

    if (horariosDoDia.length > 0) {
      this.turnos = horariosDoDia.map(horario => ({
        inicio: moment(horario.horarioAbertura, 'HH:mm:ss').toDate(),
        fim: moment(horario.horarioFechamento, 'HH:mm:ss').toDate(),
        id: horario.id
      }));
    } else {
      this.turnos = [{ inicio: null, fim: null }];
    }
  }

  toggleDia(dia: number) {
    // Não permitir alteração de dias quando estiver editando um horário
    if (this.horarioParaEditar) {
      return;
    }
    
    const index = this.diasSelecionados.indexOf(dia);
    if (index > -1) {
      this.diasSelecionados.splice(index, 1);
    } else {
      this.diasSelecionados.push(dia);
    }
  }

  adicionarTurno() {
    this.turnos.push({ inicio: null, fim: null });
  }

  removerTurno(i: number) {
    if(this.turnos[i].id){
      this.turnos[i].removido = true;
    } else {
      this.turnos.splice(i, 1);
    }

  }

  removerHorario() {
    // Abrir modal de confirmação Kendo
    const windowRef: DialogRef = this.dialogService.open({
      title: 'Confirmar Remoção',
      content: ModalConfirmacaoComponent,
      minWidth: 400,
      width: 500,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);

    windowRef.content.instance.titulo = 'Remover Horário';
    windowRef.content.instance.mensagem = 'Deseja realmente remover este horário?';
    windowRef.content.instance.textoConfirmacao = 'Sim, Remover';
    windowRef.content.instance.textoCancelamento = 'Cancelar';
    windowRef.content.instance.tipoConfirmacao = 'danger';

    windowRef.result.subscribe((result: any) => {
      if (result && result.confirmado) {
        this.executarRemocaoHorario();
      }
    });
  }

  private executarRemocaoHorario() {
    this.salvando = true;

    this.editService.removaHorario(this.horarioParaEditar, false).then((data) => {
      this.salvando = false;
      if (data.sucesso) {
        this.dialogRef.close({ salvou: true, removeu: true });
      } else {
        alert(data.mensagem || 'Erro ao remover horário');
      }
    }).catch(erro => {
      this.salvando = false;
      alert('Erro ao remover horário: ' + erro);
    });
  }

  salvar() {
    this.msgErro = null;
    if (this.diasSelecionados.length === 0) {
      this.exibaErro('Selecione pelo menos um dia da semana\'')
      return;
    }

    if (this.turnos.some(t => !t.inicio || !t.fim)) {
      this.exibaErro('Preencha todos os horários dos turnos')
      return;
    }

    this.salvando = true;

    let horarios = [];

    this.diasSelecionados.forEach(dia => {
      this.turnos.forEach(turno => {
        const horario: any = {
          id: turno.id,
          diaDaSemana: dia,
          servico: this.servico.id,
          horarioAbertura: moment(turno.inicio).format('HH:mm:ss'),
          horarioFechamento: moment(turno.fim).format('HH:mm:ss'),
          funciona: true
        };

        if (turno.removido)
          horario.removido = true;

        horarios.push(horario)
      });
    });


    this.editService.salveHorarios(this.empresa, this.servico.id, horarios).then( () => {
      this.salvando = false;
      this.dialogRef.close({ salvou: true });
    }).catch((erro) => {
      this.salvando = false;
      console.error(erro)
      this.exibaErro(erro)
    })
  }

  exibaErro(err){
    this.msgErro = err;
  }

  cancelar() {
    this.dialogRef.close();
  }

  calculeDataMinima(horario: any){
    // Se fim for definido e estiver entre 00:01 e 04:00
    horario.dataMinimaFim = horario.inicio
    if (horario.fim) {
      const horaFim = horario.fim.getHours();
      const minutoFim = horario.fim.getMinutes();
      if ((horaFim >= 0 && horaFim < 6) || (horaFim === 6 && minutoFim === 0)){
        // Criar objetos de comparação
        const limiteMadrugada = new Date(horario.fim);
       // limiteMadrugada.setDate(limiteMadrugada.getDate() + 1); // joga para amanhã
        limiteMadrugada.setHours(0, 0, 0, 0);
        console.log("madrugada", limiteMadrugada)
        horario.dataMinimaFim = limiteMadrugada
      }
    }
  }
}
